"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-benedetto-val-di-sambro": {
    "e2fc800e": [{
      "hkey": "87dcdb5c",
      "slug": "ripoli-santa-cristina",
      "name": "Ripoli Santa Cristina",
      "primary": true,
      "skipSearch": false
    }],
    "ripoli": [{
      "hkey": "87dcdb5c",
      "slug": "ripoli-santa-cristina",
      "name": "Ripoli Santa Cristina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;